import React from 'react'
import { findIndex } from 'lodash'

import { displayHours } from '../helpers/officeHours'

export default ({clinic}) => {
  if (!clinic) return null

  return (
    <div className="flex-0">
      { displayHours(clinic) }
    </div>
  )
}